var exports = {
  "N": "inputLabel__xF585x",
};

module.exports = exports;
